var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:['object-cover', {
        '-lazyload': _vm.lazyload,
        '-lazyload-preloader': _vm.lazyload && _vm.placeholder,
    }],attrs:{"src":_vm.lazyload && _vm.placeholder ? _vm.placeholder : _vm.lazyload && _vm.src,"data-src":_vm.lazyload && _vm.src,"srcset":!_vm.lazyload && _vm.srcset,"data-srcset":_vm.lazyload && _vm.srcset,"sizes":_vm.sizes}})}
var staticRenderFns = []

export { render, staticRenderFns }